import { render, staticRenderFns } from "./StoreItemContainer.vue?vue&type=template&id=668d80ae&scoped=true"
import script from "./StoreItemContainer.vue?vue&type=script&lang=js"
export * from "./StoreItemContainer.vue?vue&type=script&lang=js"
import style0 from "./StoreItemContainer.vue?vue&type=style&index=0&id=668d80ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d80ae",
  null
  
)

export default component.exports